export interface PlayerProfile {
  name: string;
  highScore: number;
  gamesPlayed: number;
  totalScore: number;
  bestWave: number;
  createdAt: number;
}

const STORAGE_KEY = 'rollerToaster_players';
const CURRENT_PLAYER_KEY = 'rollerToaster_currentPlayer';

// Default players
const DEFAULT_PLAYERS: PlayerProfile[] = [
  { name: 'PLAYER 1', highScore: 0, gamesPlayed: 0, totalScore: 0, bestWave: 0, createdAt: Date.now() },
  { name: 'PLAYER 2', highScore: 0, gamesPlayed: 0, totalScore: 0, bestWave: 0, createdAt: Date.now() },
  { name: 'PLAYER 3', highScore: 0, gamesPlayed: 0, totalScore: 0, bestWave: 0, createdAt: Date.now() },
];

let players: PlayerProfile[] = [];
let currentPlayerIndex: number = 0;

// Initialize players from localStorage
export function initializePlayers(): void {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved) {
    try {
      players = JSON.parse(saved);
    } catch {
      players = [...DEFAULT_PLAYERS];
      savePlayers();
    }
  } else {
    players = [...DEFAULT_PLAYERS];
    savePlayers();
  }

  // Load current player index
  const savedIndex = localStorage.getItem(CURRENT_PLAYER_KEY);
  if (savedIndex) {
    currentPlayerIndex = parseInt(savedIndex, 10);
    if (currentPlayerIndex >= players.length) {
      currentPlayerIndex = 0;
    }
  }
}

function savePlayers(): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(players));
}

export function getPlayers(): PlayerProfile[] {
  return players;
}

export function getCurrentPlayer(): PlayerProfile {
  return players[currentPlayerIndex];
}

export function getCurrentPlayerIndex(): number {
  return currentPlayerIndex;
}

export function setCurrentPlayer(index: number): void {
  if (index >= 0 && index < players.length) {
    currentPlayerIndex = index;
    localStorage.setItem(CURRENT_PLAYER_KEY, index.toString());
  }
}

export function updatePlayerScore(score: number, wave: number): void {
  const player = players[currentPlayerIndex];
  player.gamesPlayed++;
  player.totalScore += score;
  
  if (score > player.highScore) {
    player.highScore = score;
  }
  
  if (wave > player.bestWave) {
    player.bestWave = wave;
  }
  
  savePlayers();
  
  // Also update legacy high score for backwards compatibility
  const legacyHighScore = parseInt(localStorage.getItem('rollerToaster_highScore') || '0', 10);
  if (score > legacyHighScore) {
    localStorage.setItem('rollerToaster_highScore', score.toString());
  }
}

export function renamePlayer(index: number, newName: string): void {
  if (index >= 0 && index < players.length) {
    players[index].name = newName.toUpperCase().substring(0, 12);
    savePlayers();
  }
}

export function resetPlayerStats(index: number): void {
  if (index >= 0 && index < players.length) {
    players[index].highScore = 0;
    players[index].gamesPlayed = 0;
    players[index].totalScore = 0;
    players[index].bestWave = 0;
    savePlayers();
  }
}

// Initialize on module load
initializePlayers();





